<template>
  <v-layout
    column
    justify-start
    fill-height
    class="right-sidebar-open elevation-2"
  >
    <v-layout  row justify-start class="py-2">

      <div class="layertitleTextContainer">
        <span class="layerTitle">{{ $tc(`${sidebarOpen}`, 2) }}</span>
        <!-- <span class="layerProfile">
          Default
          <v-icon
            slot="append"
            class="defaultChevron"
          >
            mdi-chevron-down
          </v-icon>
        </span> -->
      </div>
     
    </v-layout>
    <right-sidebar-layers v-show="sidebarOpen === 'layers'" />
    <right-sidebar-tools v-if="sidebarOpen === 'tools'" />
    
  </v-layout>
</template>

<script>
import RightSidebarButton from "@/components/Network/RightSidebar/RightSidebarButton";
import { mapActions } from "vuex";
import RightSidebarTools from "@/components/Network/RightSidebar/RightSidebarTools";
import RightSidebarLayers from "@/components/Network/RightSidebar/RightSidebarLayers";

export default {
  name: "RightSidebarOpen",

  components: { RightSidebarLayers, RightSidebarTools, RightSidebarButton},

  computed: {
    /**
     * Determines whether the right sidebar is open or closed.
     * @returns {boolean}
     */
    sidebarOpen() {
      return this.$store.getters.getCurrentlyOpenTabSidebar;
    }
  },

  methods: {
    ...mapActions(["setOpenTabSidebar"]),

    /**
     * Open the selected tab
     * @param tab
     */
    openTab(tab) {
      this.setOpenTabSidebar(tab);
    }
  }
};
</script>

<style scoped>

.layertitleTextContainer {
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-left: 15px;
}

.layerProfile {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: rgba(118, 118, 118, 0.5)
}

.layerTitle {
  font-family: 'Lato';
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 20px;
  color: #767676;
  text-transform: uppercase;
}
.right-sidebar-open {
  background-color: white;
  position: absolute;
  width: 300px;
  z-index: 10;
  right: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/Network/RightSidebar/RightSidebarOpen.vue